<template>
  <v-app>
    <header class="navbar">
      <transition name="navbar-switch" mode="in-out">
        <component :is="navbarState ? 'TheNavbarBeta' : 'TheNavbar'" />
      </transition>
    </header>

    <v-content>
      <TheContent />
    </v-content>

    <v-footer height="auto">
      <TheFooter />
    </v-footer>
  </v-app>
</template>

<script>
import TheNavbar from '@/components/navigation/TheNavbar.vue';
import TheNavbarBeta from '@/components/navigation/TheNavbarBeta.vue';
import TheContent from '@/components/TheContent.vue';
import TheFooter from '@/components/navigation/TheFooter.vue';

export default {
  name: 'BRIApp',
  components: {
    TheNavbar,
    TheNavbarBeta,
    TheContent,
    TheFooter,
  },
  data() {
    return {};
  },
  computed: {
    navbarState() {
      return this.$store.getters['general/navbarState'];
    },
  },
};
</script>

<style lang="stylus">
@import 'assets/styles/main.styl';

.navbar {
  z-index: 99;
}

.navbar-switch-enter-active, .navbar-switch-leave-active {
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar-switch-enter, .navbar-switch-leave-to {
  transform: translateY(-64px) !important;
}

.navbar-switch-enter-to, .navbar-switch-leave {
  transform: translateY(0px) !important;
}
</style>
